<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <BHanhDocOut
        ref="banHanhMainContent"
        :quote="quote"
        :docId="docId"
        :docStatus="docStatus"
        :publisherId="publisherId"
        :docReceiverIds="docReceiverIds"
        :docTypeId="docTypeId"
        :deptEditorId="deptEditorId"
        :otherReceivePlaces="otherReceivePlaces"
        :signedAttachmentId="signedAttachmentId"
        @success="$emit('success')"
        @update="$emit('update')"
        @processing="(event) => (isProcessing = event.isProcessing)"
      >
      </BHanhDocOut>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action" slot="">
        <el-button
          class="dialogBtnPrimary"
          @click="banHanh"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-arrow-circle-right font-size__small'
                : 'el-icon-loading',
            ]"
          ></i>
          &nbsp;Ban hành
        </el-button>

        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="cancel"
          >Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import BHanhDocOut from "./BHanhDocOut";
// import {EventBus} from "../../../event-bus";

export default {
  props: [
    "docId",
    "signedAttachmentId",
    "isOpen",
    "quote",
    "publisherId",
    "docStatus",
    "docReceiverIds",
    "otherReceivePlaces",
    "docTypeId",
    "deptEditorId",
    "accessTokenSCA",
  ],
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    BHanhDocOut,
  },
  data() {
    return {
      isProcessing: false,
    };
  },
  methods: {
    banHanh() {
      this.$refs.banHanhMainContent.banHanh();
      // EventBus.$emit('banHanh', {});
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/BHanhDocOutDialog.vue